import React from 'react';
import './Excerpt.css';

function Excerpt() {
  return (
    <section className="excerpt-section" id="excerpt">
      <div className="excerpt-inner reveal">
        <div className="excerpt-header">
          <div className="red-bar"></div>
          <span>From Chapter I</span>
        </div>
        <div className="excerpt-text">
          A chill raises the hair on my arms… My heart races when efforts to free myself cause my chair to bang against the floor… Pondering my whereabouts, something rough cuts into my skin.
          <span className="callout">THAT'S WHEN I NOTICE SOMETHING COVERING MY EYES.</span>
          To my left, the creaking sound of rusted door hinges are followed by footsteps. <em>Who's there?</em>
        </div>
        <p className="excerpt-cite">— Saving Grace, Chapter I</p>

        <div style={{ height: '80px' }}></div>

        <div className="excerpt-header">
          <div className="red-bar"></div>
          <span>From Chapter IX</span>
        </div>
        <div className="excerpt-text">
          "How long has he been out?" A man with a sophisticated voice asks. The sweet smell of tobacco fills the room, reminding me of my grandfather's pipe… A pungent smell replaces the sweet tobacco smell. My head feels like it is on fire. I twitch when he announces, "he's awake!"
          <span className="callout">"MR. GRACE," THE BOSS SAYS… "WHAT WERE YOU LOOKING FOR?"</span>
        </div>
        <p className="excerpt-cite">— Saving Grace, Chapter IX</p>
      </div>
    </section>
  );
}

export default Excerpt;
